import { useExperimentContext } from '../../context/experimentContext';
import { EXPERIMENTS } from '../../constants/experiment';
import type { ExperimentName } from '../../constants/experiment';

interface ExperimentVariantResult {
  readonly variant: string;
  readonly isLoading: boolean;
}

export function useExperimentVariant(experimentName: ExperimentName): ExperimentVariantResult {
  const { isReady, client } = useExperimentContext();
  const defaultVariant = EXPERIMENTS[experimentName].default;

  if (!isReady || !client) {
    return { variant: defaultVariant, isLoading: true };
  }

  const assigned = client.variant(experimentName);
  const variant = assigned?.value || defaultVariant;

  return { variant, isLoading: false };
}
